import { render, staticRenderFns } from "./EyeTraitPreview.vue?vue&type=template&id=35f0964d&scoped=true&"
import script from "./EyeTraitPreview.vue?vue&type=script&lang=ts&"
export * from "./EyeTraitPreview.vue?vue&type=script&lang=ts&"
import style0 from "./EyeTraitPreview.vue?vue&type=style&index=0&id=35f0964d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f0964d",
  null
  
)

export default component.exports